import { mutator } from 'satcheljs';
import { toggleAccessibilityOption } from '../actions/internalActions';
import store from '../store/store';

/**
 * Mutator to toggle the selected option
 */
export default mutator(toggleAccessibilityOption, actionMessage => {
    store().isEnabled = actionMessage.selectedOption;
});
